
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: {}
	})
	export default class PrescriptionItem extends Vue {
		@Prop({ required: false, default: false }) disabled!: boolean;
		@Prop({ required: false, default: false }) showImage!: boolean;
		@Prop({ required: false, default: false }) itemDisabled!: string;
		@Prop({ required: false, default: '' }) description!: string;
		@Prop({ required: false, default: () => [] }) disabledValues!: string[];
		@Prop({ required: true, default: '' }) imgPath!: string;
		@Prop({ required: true, default: '' }) display!: string;
		@Prop({ required: false, default: 'row' }) variant!: 'row' | 'column';

		getProperProps(props) {
			return {
				disabled: props.disabled || undefined,
				showImage: props.showImage || undefined,
				description: props.description || undefined,
				imgPath: props.imgPath || undefined,
				display: props.display || undefined
			};
		}

		isOptionDisabled(option: string) {
			return this.disabledValues.includes(option);
		}

		isDisabledByScan(value: string) {
			if (this.$state.currentRoute === '/saved-rx') {
				return false;
			}
			switch (value) {
				case 'left':
					return !this.$state.biometric.leftScanExists;
				case 'right':
					return !this.$state.biometric.rightScanExists;
				case 'both':
					return !this.$state.biometric.bothScansExist;
				default:
					return false;
			}
		}

		isDisabled(value) {
			return this.disabled || this.isOptionDisabled(value) || this.isDisabledByScan(value);
		}
	}
